import { render, staticRenderFns } from "./menuConfig.vue?vue&type=template&id=7bf00afc&scoped=true&"
import script from "./menuConfig.vue?vue&type=script&lang=js&"
export * from "./menuConfig.vue?vue&type=script&lang=js&"
import style0 from "./menuConfig.vue?vue&type=style&index=0&id=7bf00afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf00afc",
  null
  
)

export default component.exports